import {
  Breadcrumb,
  Row,
  Col,
  Button,
  Form,
  Input,
  Progress,
  Spin,
} from "antd";
import "../../accountList/AccountListPage.css"

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { modalConfirmCancel, modalCustom } from "../../modal/modalCustom";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { SIDEBAR_CONSTANT } from "../../../constant/sidebar.constant";
import { RESOURCE_LIST_CONSTANT } from "../../../constant/resourcelist.constant";
import { IoCloudUploadOutline } from "react-icons/io5";
import { AiFillDelete } from "react-icons/ai";
import { useDropzone } from 'react-dropzone';
import isEmpty from "lodash/isEmpty";
import { convertFileSizePreview, getRandomInt } from "../../../function/functions";
import uploadService from "../../../service/uploadService";
import resourceListService from "../../../service/resourceListService";
import { ROUTER_CONSTANT } from "../../../constant/router.constant";

const ResourceListAddForm = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.loginData.token);
  const baseUrl = ROUTER_CONSTANT.HOME + ROUTER_CONSTANT.RESOURCE_LIST;
  const [form] = Form.useForm();

  const [dataResource, setDataResource] = useState(
    {
      resource_id: null,
      resource_name: null,
      description: null,
      logo: null,
    }
  );

  const [fileList, setFileList] = useState([]);
  const [progressValue, setProgressValue] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [activeSpin, setActiveSpin] = useState(false);

  const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpg': ['.png', '.jpg', '.jpeg',],
    },
    maxFiles: 1,
    maxSize: 2000000,
  });

  const okFunction = () => {
    navigate(`${baseUrl}`);
  }

  const failedFunction = () => {
    // TODO : Keep It for future use, click button after pop up failed modal
  }

  const handleSuccessAddResource = () => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_TITLE_ADD_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_CONTENT_ADD_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_OK_BUTTON_ADD_RESOURCES,
      okFunction,
      "success"
    )
  }

  const handleFailedAddResource = () => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_TITLE_ADD_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_CONTENT_ADD_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_OK_BUTTON_ADD_RESOURCES,
      failedFunction,
      "failed"
    )
  }

  const handleFailedAddResourceWithMessage = (failedMessage) => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_TITLE_ADD_RESOURCES,
      failedMessage,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_OK_BUTTON_ADD_RESOURCES,
      failedFunction,
      "failed"
    )
  }

  const handleChange = (event) => {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;
    setDataResource({ ...dataResource, [fieldName]: fieldValue });
  }

  const handleConfirmCancel = () => {
    if (!form.getFieldValue("resource_id") &&
      !form.getFieldValue("resource_name") &&
      !form.getFieldValue("description") &&
      !form.getFieldValue("logo")
    ) {
      return okFunction();
    }

    modalConfirmCancel(
      RESOURCE_LIST_CONSTANT.MODAL_CANCEL_TITLE,
      RESOURCE_LIST_CONSTANT.MODAL_CANCEL_CONTENT,
      RESOURCE_LIST_CONSTANT.MODAL_CANCEL_OK_TEXT,
      RESOURCE_LIST_CONSTANT.MODAL_CANCEL_NO_TEXT,
      okFunction
    );
  }

  const handleSave = () => {
    setActiveSpin(true);
    uploadService.uploadFile(fileList[0])
      .then((response) => {
        setActiveSpin(false);
        setDataResource({ ...dataResource, logo: response.data.additionalEntity.result.path });
        form.setFieldsValue({ logo: response.data.additionalEntity.result.path });
        form.submit();
      })
      .catch((error) => {
        setActiveSpin(false);
        form.setFieldsValue({ logo: null });
        form.submit();
      })
  }

  const handleSubmitSuccess = () => {
    setActiveSpin(true);
    resourceListService.addResource(token, dataResource)
      .then((response) => {
        setActiveSpin(false);
        if (response.data.nexsoft.payload.status.success) {
          handleSuccessAddResource();
        } else {
          handleFailedAddResourceWithMessage(response.data.nexsoft.payload.status.message);
        }
      })
      .catch((error) => {
        setActiveSpin(false);
        handleFailedAddResource();
      })
  }

  const handleRemoveUploadLogo = () => {
    setFileList([]);
    setProgressValue(0);
    clearInterval(intervalId);
    form.setFieldsValue({
      logo: null
    });
  }

  const templateUploadLogo = () => {
    return (
      <>
        <div className="form-upload-logo-header-container">

          {isEmpty(fileList) || progressValue < 100 ?
            <div className="form-upload-logo-style">
              <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <IoCloudUploadOutline className="form-upload-logo-icon" />
                <br />
                {progressValue === 0 &&
                  <>
                    <span>
                      {RESOURCE_LIST_CONSTANT.PLACEHOLDER_UPLOAD_LOGO_CLICK}
                    </span>
                    {RESOURCE_LIST_CONSTANT.PLACEHOLDER_UPLOAD_LOGO_DRAGDROP}
                  </>
                }
              </div>
              {progressValue !== 0 &&
                <>
                  <Row justify="space-between">
                    Uploading...
                    <div onClick={() => handleRemoveUploadLogo()}>X</div>
                  </Row>
                  <Progress percent={progressValue} />
                </>
              }
            </div>
            :
            <Row className="form-upload-logo-success-style" align="middle">
              <Col xs={24} md={6}>
                <img
                  className="add-resource-logo-list-style"
                  src={URL.createObjectURL(fileList[0])}
                  alt="Upload Logo"
                />
              </Col>

              <Col xs={24} md={12} style={{ textAlign: "center" }}>
                {`${fileList[0].path} (${convertFileSizePreview(fileList[0].size)})`}
              </Col>

              <Col xs={24} md={6} style={{ textAlign: "right" }}>
                <AiFillDelete
                  onClick={() => handleRemoveUploadLogo()}
                  style={{ color: "red", cursor: "pointer" }}
                />
              </Col>
            </Row>
          }
        </div>
      </>
    )
  }

  useEffect(() => {
    const checkValidationFile = () => {
      if (fileRejections.length > 0) {
        form.setFieldsValue({
          logo: null
        });
        form.setFields([
          {
            name: 'logo',
            errors: [RESOURCE_LIST_CONSTANT.VALIDATION_LOGO_REQUIRED],
          },
        ]);
        setFileList([]);
      }

      if (acceptedFiles.length > 0) {
        let maxProgressValue = 100;
        let dividedPart = getRandomInt(10);
        let segment = maxProgressValue / dividedPart;
        let currentProgressValue = 0;
        let interval = 500 / dividedPart;

        if (acceptedFiles[0].size >= 500000 && acceptedFiles[0].size < 1000000) {
          interval = 1000 / dividedPart;
        }
        if (acceptedFiles[0].size >= 1000000) {
          interval = 1500 / dividedPart;
        }

        let intervalIdFunction = setInterval(() => {
          currentProgressValue += segment
          setProgressValue(Math.floor(currentProgressValue))
          if (currentProgressValue > maxProgressValue) {
            setFileList(acceptedFiles);
            setProgressValue(100);
            form.setFields([
              {
                name: 'logo',
                errors: null,
              },
            ]);
            clearInterval(intervalIdFunction);
          }
        }, interval);
        setIntervalId(intervalIdFunction);
      }
    }

    checkValidationFile();
  }, [form, acceptedFiles, fileRejections]);

  return (
    <>
      <Row>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>{SIDEBAR_CONSTANT.MENU_SETTING_LIST}</Breadcrumb.Item>
          <Breadcrumb.Item
            onClick={() => handleConfirmCancel()}
            style={{ cursor: "pointer" }}
          >
            {RESOURCE_LIST_CONSTANT.MENU_RESOURCE_LIST}
          </Breadcrumb.Item>
          <Breadcrumb.Item>{RESOURCE_LIST_CONSTANT.BUTTON_RESOURCE_LIST_ADD}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row className="accountlist-title">
        <MdOutlineArrowBackIosNew
          onClick={() => handleConfirmCancel()}
          className="arrow-back-form-title" />
        {RESOURCE_LIST_CONSTANT.BUTTON_RESOURCE_LIST_ADD}
      </Row>

      <br />

      <Form
        form={form}
        layout="vertical"
        onFinish={() => handleSubmitSuccess()}
      >

        <Row className="card-white-box-container">
          <Col xs={24} md={24}>
            <div className="card-white-box">
              <Row>
                <Col xs={24} md={15}>
                  <Form.Item
                    name="resource_id"
                    label="Resource ID"
                    rules={[
                      {
                        required: true,
                        message: RESOURCE_LIST_CONSTANT.VALIDATION_RESOURCE_ID_REQUIRED,
                        pattern: new RegExp(/^[a-z][a-z0-9]+$/),
                        validateTrigger: "onSubmit",
                      },
                    ]}
                  >
                    <Input placeholder={RESOURCE_LIST_CONSTANT.PLACEHOLDER_RESOURCE_ID}
                      name="resource_id"
                      onChange={(event) => handleChange(event)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} md={15}>
                  <Form.Item
                    name="resource_name"
                    label="Resource Name"
                    rules={[{
                      required: true,
                      message: RESOURCE_LIST_CONSTANT.VALIDATION_RESOURCE_NAME_REQUIRED,
                      validateTrigger: "onSubmit",
                    }]}
                  >
                    <Input placeholder={RESOURCE_LIST_CONSTANT.PLACEHOLDER_RESOURCE_NAME}
                      name="resource_name"
                      onChange={(event) => handleChange(event)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} md={15}>
                  <Form.Item
                    name="description"
                    label={
                      <div>
                        Description
                        <span className="form-label-optional"> (Optional) </span>
                      </div>
                    }
                  >
                    <Input
                      name="description"
                      onChange={(event) => handleChange(event)}
                      placeholder={RESOURCE_LIST_CONSTANT.PLACEHOLDER_DESCRIPTION} />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} md={15}>
                  <Form.Item
                    name="logo"
                    label="Upload Logo"
                    rules={[{
                      required: true,
                      message: RESOURCE_LIST_CONSTANT.VALIDATION_LOGO_REQUIRED,
                      validateTrigger: "onSubmit",
                    }]}
                  >
                    {templateUploadLogo()}
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Row justify="end">
          <Col>
            <Form.Item>
              <Button className="form-button-footer-style" key="cancel" onClick={() => handleConfirmCancel()}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item shouldUpdate>
              {() => (
                <Spin spinning={activeSpin}>
                  <Button className="form-button-footer-style" key="save"
                    onClick={() => handleSave()}
                    type="primary">
                    Save
                  </Button>
                </Spin>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default ResourceListAddForm;